module.exports = __webpack_public_path__ + "static/img/chanel.4ec407fe.png";